<template>
  <div v-if="visible" class="eis-wait-overlay">
    <div class="eis-wait-dialog">
      <p class="eis-wait-title">
        {{ slow ? 'Still submitting to MRA…' : 'Submitting to MRA…' }}
      </p>
      <p class="eis-wait-sub">{{ elapsedLabel }} elapsed</p>

      <div class="eis-wait-progress">
        <div class="eis-wait-progress-bar" :style="{ width: progressPct + '%' }"></div>
      </div>

      <button v-if="cancelable" class="eis-wait-cancel-btn" @click="cancel">
        Cancel & continue offline
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EisSubmitProgressDialog',
  data() {
    return {
      visible: false,
      slow: false,
      cancelable: false,
      startedAt: null,
      hardTimeoutMs: 60000,
      elapsedMs: 0,
      tickInterval: null,
      onCancelCb: null,
    }
  },
  computed: {
    elapsedLabel() {
      return `${Math.floor(this.elapsedMs / 1000)}s`
    },
    progressPct() {
      if (!this.startedAt) return 0
      return Math.min(100, (this.elapsedMs / this.hardTimeoutMs) * 100)
    },
  },
  created() {
    this.MBS.events.$on('EIS_SUBMIT_SLOW', this.handleSlow)
    this.MBS.events.$on('EIS_SUBMIT_CANCELABLE', this.handleCancelable)
    this.MBS.events.$on('EIS_SUBMIT_DONE', this.handleDone)
  },
  beforeDestroy() {
    this.MBS.events.$off('EIS_SUBMIT_SLOW', this.handleSlow)
    this.MBS.events.$off('EIS_SUBMIT_CANCELABLE', this.handleCancelable)
    this.MBS.events.$off('EIS_SUBMIT_DONE', this.handleDone)
    this.stopTicking()
  },
  methods: {
    handleSlow({ elapsed_ms }) {
      this.visible = true
      this.slow = true
      if (!this.startedAt) this.startedAt = Date.now() - elapsed_ms
      this.startTicking()
    },
    handleCancelable({ started_at, hard_timeout_ms, onCancel }) {
      this.visible = true
      this.startedAt = started_at
      this.hardTimeoutMs = hard_timeout_ms
      this.cancelable = true
      this.onCancelCb = onCancel
      this.startTicking()
    },
    handleDone() {
      this.reset()
    },
    startTicking() {
      if (this.tickInterval) return
      this.tickInterval = setInterval(() => {
        this.elapsedMs = Date.now() - this.startedAt
      }, 250)
    },
    stopTicking() {
      clearInterval(this.tickInterval)
      this.tickInterval = null
    },
    cancel() {
      if (this.onCancelCb) this.onCancelCb()
      this.reset()
    },
    reset() {
      this.visible = false
      this.slow = false
      this.cancelable = false
      this.startedAt = null
      this.elapsedMs = 0
      this.onCancelCb = null
      this.stopTicking()
    },
  },
}
</script>

<style scoped>
.eis-wait-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.eis-wait-dialog {
  background: #fff;
  border-radius: 8px;
  padding: 24px 28px;
  min-width: 280px;
  text-align: center;
}
.eis-wait-title { font-weight: 600; margin: 0 0 4px; }
.eis-wait-sub { color: #666; font-size: 13px; margin: 0 0 12px; }
.eis-wait-progress {
  height: 6px;
  background: #eee;
  border-radius: 3px;
  overflow: hidden;
  margin-bottom: 16px;
}
.eis-wait-progress-bar {
  height: 100%;
  background: #024959;
  transition: width 0.25s linear;
}
.eis-wait-cancel-btn {
  border: 1px solid #d1d5db;
  background: #fff;
  border-radius: 6px;
  padding: 8px 16px;
  cursor: pointer;
}
.eis-wait-cancel-btn:hover { background: #f9fafb; }
</style>